import styled from "@emotion/styled";

import { ContentItemPlusOpinion } from "scmp-app/components/content/content-item-render/variants/plus-opinion";
import { ContentItemPlusPrimary } from "scmp-app/components/content/content-item-render/variants/plus-primary";

export const StyledContentItemPlusPrimary = styled(ContentItemPlusPrimary)``;

export const StyledContentItemPlusOpinion = styled(ContentItemPlusOpinion)``;
